import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../../shared/commonfunctions";
import { Formik, Form, FieldArray } from "formik";
import { schema } from "../../shared/FormikSchema";
import StageLayout from "../../Layouts/StageLayout";
import routesData from "../../shared/routes.json";
import Styles from "../../pages/Styles/NomineeStyles.module.scss";
import { INominee } from "../../shared/dtos";
import icon from "../../Components/assets/Images/iconnew.svg";
import NomineeForm from "./NomineeForm";
import StartOverBackDrop from "../../Components/StartOverBackDrop";
import BackDrop from "../../Components/BackDrop";
import { v4 as uuidv4 } from "uuid";
import dayjs, { Dayjs } from "dayjs";
import { nomineeID } from "../../shared/commonData";
import ErrorSnackBar from "../../Components/SnackBars/ErrorSnackBar";
import keyboardicon from "../../Components/assets/Images/nomineeicongrey.svg";
import {
  GetNomineeDetailsAPICall,
  GetrelationDropDownAPICall,
  NomineeStageDetailsAPICall,
  UpdateNomineeDetailsAPICall,
} from "../NomineeUpdate/NomineeUpdateAPICalls";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import {
  LocationCheckAPICall,
  SaveIpAddressAPICall,
} from "../../shared/APICalls";
import SnackBar from "../../Components/SnackBars/SnackBar";
import axios from "axios";
import proofEmpty from "../../Components/assets/Images/proofemptycircle.svg";
import proofDone from "../../Components/assets/Images/prooftickedcircle.svg";

const statesData = [
  {
    id: "Jammu and Kashmir",
    sequence: 1,
    value: "Jammu and Kashmir",
  },
  {
    id: "Himachal Pradesh",
    sequence: 2,
    value: "Himachal Pradesh",
  },
  {
    id: "Punjab",
    sequence: 3,
    value: "Punjab",
  },
  {
    id: "Chandigarh",
    sequence: 4,
    value: "Chandigarh",
  },
  {
    id: "Uttarakhand",
    sequence: 5,
    value: "Uttarakhand",
  },
  {
    id: "Haryana",
    sequence: 6,
    value: "Haryana",
  },
  {
    id: "Delhi",
    sequence: 7,
    value: "Delhi",
  },
  {
    id: "Rajasthan",
    sequence: 8,
    value: "Rajasthan",
  },
  {
    id: "Uttar Pradesh",
    sequence: 9,
    value: "Uttar Pradesh",
  },
  {
    id: "Bihar",
    sequence: 10,
    value: "Bihar",
  },
  {
    id: "Sikkim",
    sequence: 11,
    value: "Sikkim",
  },
  {
    id: "Arunachal Pradesh",
    sequence: 12,
    value: "Arunachal Pradesh",
  },
  {
    id: "Assam",
    sequence: 13,
    value: "Assam",
  },
  {
    id: "Manipur",
    sequence: 14,
    value: "Manipur",
  },
  {
    id: "Mizoram",
    sequence: 15,
    value: "Mizoram",
  },
  {
    id: "Tripura",
    sequence: 16,
    value: "Tripura",
  },
  {
    id: "Meghalaya",
    sequence: 17,
    value: "Meghalaya",
  },
  {
    id: "Nagaland",
    sequence: 18,
    value: "Nagaland",
  },
  {
    id: "West Bengal",
    sequence: 19,
    value: "West Bengal",
  },
  {
    id: "Jharkhand",
    sequence: 20,
    value: "Jharkhand",
  },
  {
    id: "Orissa",
    sequence: 21,
    value: "Orissa",
  },
  {
    id: "Chhattisgarh",
    sequence: 22,
    value: "Chhattisgarh",
  },
  {
    id: "Madhya Pradesh",
    sequence: 23,
    value: "Madhya Pradesh",
  },
  {
    id: "Gujarat",
    sequence: 24,
    value: "Gujarat",
  },
  {
    id: "Daman and Diu",
    sequence: 25,
    value: "Daman and Diu",
  },
  {
    id: "Dadra and Nagar Haveli",
    sequence: 26,
    value: "Dadra and Nagar Haveli",
  },
  {
    id: "Maharashtra",
    sequence: 27,
    value: "Maharashtra",
  },
  {
    id: "Andhra Pradesh",
    sequence: 28,
    value: "Andhra Pradesh",
  },
  {
    id: "Karnataka",
    sequence: 29,
    value: "Karnataka",
  },
  {
    id: "Goa",
    sequence: 30,
    value: "Goa",
  },
  {
    id: "Lakshadweep",
    sequence: 31,
    value: "Lakshadweep",
  },
  {
    id: "Kerala",
    sequence: 32,
    value: "Kerala",
  },
  {
    id: "Tamil Nadu",
    sequence: 33,
    value: "Tamil Nadu",
  },
  {
    id: "Puducherry",
    sequence: 34,
    value: "Puducherry",
  },
  {
    id: "Andaman and Nicobar Islands",
    sequence: 35,
    value: "Andaman and Nicobar Islands",
  },
  {
    id: "APO",
    sequence: 36,
    value: "APO",
  },
  {
    id: "Telangana",
    sequence: 37,
    value: "Telangana",
  },
  {
    id: "Ladakh",
    sequence: 38,
    value: "Ladakh",
  },
];

export default function NomineesPage() {
  const [address, setaddress] = useState({
    address: " ",
    city: "",
    pincode: "",
    State: "",
  });
  const navigate = useNavigate();
  //   const [percentageTotal, setPercentageTotal] = useState(0);
  const [assignIndex, setAssignIndex] = useState(0);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState<boolean[]>(
    [],
  );
  const [showGuardianAdditionalDetails, setShowGuardianAdditionalDetails] =
    useState<boolean[]>([]);
  const [relationShipData, setRelationShipData] = useState<any>([]);
  const [loading, setloading] = useState(false);
  const [startOverloading, setstartOverloading] = useState(false);
  const [ageError, setageError] = useState(false);
  const [gaurdianData, setgaurdianData] = useState(false);
  const [relationError, setrelationError] = useState(false);
  const [dobError, setDobError] = useState("");
  const [completedStages, setCompletedStages] = useState<any>();
  const [backdrop, setBackDrop] = useState(false);
  const [prefilloading, setprefilloading] = useState(true);
  const [rejectMessage, setRejectMessage] = useState("");
  const [prefillData, setPrefillData] = useState<any>([
    {
      id: uuidv4(),
      nomineeFullName: "",
      nomineeEmail: "",
      nomineeAddress: "",
      nomineeDateofBirth: null,
      nomineeMobileNumber: "",
      percentageofShare: "100",
      relationShip: "",
      relationshipIfOthers: "",
      gaurdianFirstName: "",
      gaurdianLastName: "",
      gaurdianDateofBirth: "",
      gaurdianEmail: "",
      gaurdianMobileNumber: "",
      gaurdianRelationWithNominee: "",
      gaurdianAddress: "",
      gaurdianAddressPinCode: "",
      gaurdianAddressCity: "",
      gaurdianAddressState: "",
      nomineeIDProof: "",
      nomineeIDProofNo: "",
      nomineeAddressCity: "",
      nomineeAddressPinCode: "",
      nomineeAddressState: "",
    },
  ]);
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");

  const [currentStage, setCurrentStage] = useState("");
  const [errormessage, seterrormessage] = useState("");
  const [IPAddress, setIPAddress] = useState("");
  const requestid: any = sessionStorage.getItem("nomineeRequestID");
  const navigationData = routesData;
  const [nominationInformation, setNominationInformation] =
    useState("nominee_status");

  const handlePreview = (data: any) => {
    //console.log(data);
  };

  // console.log("assignIndex", assignIndex);

  const convertDayJsToDate = (dateValue: any) => {
    const date = new Date(dateValue);

    const formattedDate = date.toLocaleDateString("en-GB", {
      year: "numeric",
      day: "2-digit",
      month: "2-digit",
    });
    const [month, day, year] = formattedDate.split("/");
    const formatDate = `${year}-${day}-${month}`;
    return formatDate;
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    setprefilloading(true);
    StageDetails();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchIPAddress = async () => {
      try {
        const response = await axios.get(
          "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ",
        );
        // setIPAddress(response.data);
        setIPAddress(response.data?.ip);
      } catch (err: any) {}
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (IPAddress !== "") {
      LocationCheckAPICall(IPAddress?.trim())
        .then((response: any) => {
          if (response.data.data) {
            sessionStorage.setItem("latitude", response.data.data.latitude);
            sessionStorage.setItem("longitude", response.data.data.longitude);
          }
        })
        .catch((error: any) => {
          seterrormessage("latitude and longitude not found");
          setTimeout(() => {
            seterrormessage("");
          }, 5000);
        });
    }
  }, [IPAddress]);

  const StageDetails = () => {
    let objrel: any = {
      doc_type: "nominee",
    };
    GetrelationDropDownAPICall(objrel)
      .then((response: any) => {
        const relationshipDataTemp = response.data.data.nominee_relation;
        //console.log("responseData", responseData);
        setRelationShipData([...relationshipDataTemp]);

        let objStage: any = {
          request_id: requestid,
          stage_name: "nominee_details",
        };

        NomineeStageDetailsAPICall(objStage)
          .then((response: any) => {
            const responseData = response.data;
            if (response.data.data.nominee_statement) {
              setNominationInformation(response.data.data.nominee_statement);
            }

            if (response.data.data.error_msg) {
              setRejectMessage(response.data.data.error_msg);
            }

            if (
              responseData.data.details.nominee_details &&
              responseData?.data?.details?.nominee_details[0]?.FullName &&
              responseData?.data?.details?.nominee_details[0]?.FullName !==
                "" &&
              relationshipDataTemp
            ) {
              let nomineeDetails =
                responseData.data.details.nominee_details.map(
                  (data: any, index: number) => ({
                    id: data.id ? data.id : "",
                    nomineeFullName: data.FullName,
                    nomineeEmail: data.Email,
                    nomineeAddress: data.Address,
                    nomineeDateofBirth: data.DOB ? dayjs(data.DOB) : null,
                    nomineeMobileNumber: data.Mobile,
                    percentageofShare: data.SharePercentage,
                    relationShip: relationshipDataTemp?.find(
                      (a: any) => a.value === data.Relationship,
                    ),
                    relationshipIfOthers: !data.RelationshipOthersValue
                      ? ""
                      : data.RelationshipOthersValue,
                    gaurdianFirstName: !data.GaurdianFirstName
                      ? ""
                      : data.GaurdianFirstName,
                    gaurdianLastName: !data.GaurdianLastName
                      ? ""
                      : data.GaurdianLastName,
                    gaurdianDateofBirth: !data.GuradianDOB
                      ? ""
                      : dayjs(data.GuradianDOB),
                    gaurdianEmail: !data.GuradianEmail
                      ? ""
                      : data.GuradianEmail,
                    gaurdianMobileNumber: !data.GuradianMobile
                      ? ""
                      : data.GuradianMobile,
                    gaurdianRelationWithNominee:
                      !data.GuradianRealtionWithNominee
                        ? ""
                        : relationshipDataTemp.find(
                            (a: any) =>
                              a.value.toUpperCase() ===
                              data.GuradianRealtionWithNominee.toUpperCase(),
                          ),
                    gaurdianAddress: !data.GuradianAddress
                      ? ""
                      : data.GuradianAddress,
                    gaurdianAddressPinCode: !data.GuradianAddressPinCode
                      ? ""
                      : data.GuradianAddressPinCode,
                    gaurdianAddressCity: !data.GuradianAddressCity
                      ? ""
                      : data.GuradianAddressCity,

                    gaurdianAddressState: !data.GuradianAddressState
                      ? ""
                      : statesData.filter(
                          (a: any) =>
                            a.value.toUpperCase() ===
                            data.GuradianAddressState.toUpperCase(),
                        )[0],
                    nomineeIDProof: data.NomineeIDProof
                      ? data.NomineeIDProof === ""
                        ? ""
                        : nomineeID.filter(
                            (a: any) => a === data.NomineeIDProof,
                          )[0]
                      : "",
                    nomineeIDProofNo: !data.NomineeIDProofNo
                      ? ""
                      : data.NomineeIDProofNo,
                    nomineeAddressPinCode: data.Pincode,
                    nomineeAddressCity: data.City,
                    nomineeAddressState:
                      data.State === ""
                        ? ""
                        : statesData.filter(
                            (a: any) =>
                              a.value.toUpperCase() ===
                              data.State.toUpperCase(),
                          )[0],
                  }),
                );

              setPrefillData(nomineeDetails);
              setprefilloading(false);
              //  console.log("relationshipDataTemp", relationshipDataTemp);
            }
            setprefilloading(false);
          })
          .catch((error: any) => {
            setprefilloading(false);
          });
      })
      .catch((error: any) => {});
  };

  const handleNomineeAdd = (
    values: any,
    callBack: any,
    setFieldTouched: any,
  ) => {
    setFieldTouched("nomineeFullName", false);
    setFieldTouched("nomineeEmail", false);
    setFieldTouched("nomineeAddress", false);
    setFieldTouched("nomineeDateofBirth", false);
    setFieldTouched("nomineeMobileNumber", false);
    setFieldTouched("percentageofShare", false);
    setFieldTouched("relationShip", false);
    setFieldTouched("relationshipIfOthers", false);
    setFieldTouched("gaurdianFirstName", false);
    setFieldTouched("gaurdianLastName", false);
    setFieldTouched("gaurdianDateofBirth", false);
    setFieldTouched("gaurdianEmail", false);
    setFieldTouched("gaurdianMobileNumber", false);
    setFieldTouched("gaurdianRelationWithNominee", false);
    setFieldTouched("nomineeIDProof", false);
    setFieldTouched("nomineeIDProofNo", false);
    setFieldTouched("nomineeAddressCity", false);
    setFieldTouched("nomineeAddressPinCode", false);
    setFieldTouched("nomineeAddressState", false);
    setAssignIndex((prev) => prev + 1);
    const obj: INominee = {
      id: uuidv4(),
      nomineeFullName: "",
      nomineeEmail: customerEmail,
      nomineeAddress: "",
      nomineeDateofBirth: null,
      nomineeMobileNumber: customerPhoneNumber,
      percentageofShare: "",
      relationShip: "",
      relationshipIfOthers: "",
      gaurdianFirstName: "",
      gaurdianLastName: "",
      gaurdianDateofBirth: "",
      gaurdianEmail: "",
      gaurdianMobileNumber: "",
      gaurdianRelationWithNominee: "",
      nomineeIDProof: "",
      nomineeIDProofNo: "",
      nomineeAddressCity: "",
      nomineeAddressPinCode: "",
      nomineeAddressState: "",
    };

    const nomineeCopy: any = [...values.nominees];
    nomineeCopy.push(obj);
    callBack("nominees", nomineeCopy);
  };

  const handleNomineeDelete = (values: any, callBack: any, index: any) => {
    const nomineeCopy: any = [...values.nominees];
    nomineeCopy.splice(index, 1);
    callBack("nominees", nomineeCopy);
    setShowAdditionalDetails((currentDetails) => {
      const updatedDetails = [...currentDetails];
      updatedDetails.splice(index, 1);
      return updatedDetails;
    });
    setShowGuardianAdditionalDetails((currentDetails) => {
      const updatedDetails = [...currentDetails];
      updatedDetails.splice(index, 1);
      return updatedDetails;
    });
    setAssignIndex(index - 1);
  };
  const handleChangeField = (
    name: any,
    value: any,
    callBack: any,
    index: any,
    values: any,
    setErrors: any,
    errors: any,
  ) => {
    let nomineeCopy: any = [...values.nominees];
    nomineeCopy[index][name] = value;
    callBack("nominees", nomineeCopy);
    if (name === "nomineeDateofBirth") {
      if (
        values.nominees[index].nomineeDateofBirth &&
        values.nominees[index].relationShip &&
        !values.nominees[index].relationShip.isGuardianReq
      ) {
        const dobLimit = new Date();
        dobLimit.setFullYear(dobLimit.getFullYear() - 18);
        if (
          !values.nominees[index].nomineeDateofBirth ||
          values.nominees[index].nomineeDateofBirth > dobLimit
        ) {
          // console.log("DOB is not 18 years");
        }
      }
    }
    if (name === "relationShip") {
      // Clearing Others Data
      if (
        value.value !== "Others" &&
        nomineeCopy[index]["relationshipIfOthers"]
      ) {
        nomineeCopy[index]["relationshipIfOthers"] = "";
        callBack("nominees", nomineeCopy);
      }
      if (
        values.nominees[index].nomineeDateofBirth &&
        values.nominees[index].relationShip &&
        !values.nominees[index].relationShip.isGuardianReq
      ) {
        const dobLimit = new Date();
        dobLimit.setFullYear(dobLimit.getFullYear() - 18);
        if (
          !values.nominees[index].nomineeDateofBirth ||
          values.nominees[index].nomineeDateofBirth > dobLimit
        ) {
          // console.log("DOB is not 18 years");
        }
      }
    }

    if (name === "nomineeFullName") {
      const currentRelationShip = values.nominees[index].nomineeFullName;

      const isDuplicateRelationship = values.nominees.some((nominee, i) => {
        if (i !== index && nominee.nomineeFullName === currentRelationShip) {
          return true;
        }
        return false;
      });

      if (isDuplicateRelationship) {
        setrelationError(true);

        setTimeout(() => {
          setrelationError(false);
        }, 8000);
      }
    }
    if (name === "gaurdianDateofBirth") {
      const dobLimit = new Date();
      dobLimit.setFullYear(dobLimit.getFullYear() - 18);
      if (!value || value > dobLimit) {
        // setDobError(true);

        setDobError("Gaurdian Age should not be Below 18");
        setTimeout(() => {
          setDobError("");
        }, 10000);
      }
    }
  };

  const handleNomineeEdit = (index: any) => {
    setAssignIndex(index);
  };

  const checkAgeLimit = (enteredDate: any) => {
    const dobLimit = new Date();
    dobLimit.setFullYear(dobLimit.getFullYear() - 18);
    if (!enteredDate || enteredDate > dobLimit) {
      return true;
    } else {
      return false;
    }
  };

  function nomineeDetailsSubmit(values: any) {
    let requestObject = values.map((a: any) => ({
      ...a,
      relationShip: a.relationShip.id,
      nomineeDateofBirth: convertDayJsToDate(a.nomineeDateofBirth),
    }));
    // let ArrayObject = values.map((a: any) => ({
    //   id: a.id,
    //   FullName: a.nomineeFullName.toUpperCase().trim(),
    //   Email: "",
    //   Address: "",
    //   DOB: convertDayJsToDate(a.nomineeDateofBirth),
    //   Mobile: "",
    //   SharePercentage: a.percentageofShare,
    //   Relationship: a.relationShip.value,
    //   RelationshipName: a.relationShip.value.toUpperCase(),
    //   RelationshipOthersValue: a.relationshipIfOthers
    //     ? a.relationshipIfOthers.toUpperCase().trim()
    //     : "",
    //   GuradianFullName: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianFirstName
    //       ? `${a.gaurdianFirstName.toUpperCase().trim()} ${a.gaurdianLastName.toUpperCase().trim()}`
    //       : ""
    //     : "",
    //   GaurdianFirstName: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianFirstName
    //       ? a.gaurdianFirstName.toUpperCase().trim()
    //       : ""
    //     : "",
    //   GaurdianLastName: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianLastName
    //       ? a.gaurdianLastName.toUpperCase().trim()
    //       : ""
    //     : "",
    //   GuradianDOB: "",
    //   GuradianEmail: "",
    //   GuradianMobile: "",
    //   GuradianRealtionWithNominee: checkAgeLimit(new Date(a.nomineeDateofBirth))
    //     ? a.gaurdianRelationWithNominee.value
    //       ? a.gaurdianRelationWithNominee.value.toUpperCase()
    //       : ""
    //     : "",
    //   GuradianRelationOthers: "",
    //   GuradianAddress: "",
    //   GuradianAddressPinCode: "",
    //   GuradianAddressCity: "",
    //   GuradianAddressState: "",
    //   NomineeIDProof: "",
    //   NomineeIDProofNo: "",
    //   Pincode: "",
    //   City: "",
    //   State: "",
    // }));

    let ArrayObject = values.map((a: any) => ({
      id: a.id,
      FullName: a.nomineeFullName.toUpperCase().trim(),
      Email: a.nomineeEmail || "",
      Address: (a.nomineeAddress || "").toUpperCase().trim(),
      DOB: convertDayJsToDate(a.nomineeDateofBirth),
      Mobile: a.nomineeMobileNumber || "",
      SharePercentage: a.percentageofShare,
      Relationship: a.relationShip.value,
      RelationshipName: a.relationShip.value.toUpperCase(),
      RelationshipOthersValue: a.relationshipIfOthers
        ? a.relationshipIfOthers.toUpperCase().trim()
        : "",
      GuradianFullName: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianFirstName
          ? `${a.gaurdianFirstName.toUpperCase().trim()} ${(a.gaurdianLastName || "").toUpperCase().trim()}`
          : ""
        : "",
      GaurdianFirstName: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianFirstName
          ? a.gaurdianFirstName.toUpperCase().trim()
          : ""
        : "",
      GaurdianLastName: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianLastName
          ? a.gaurdianLastName.toUpperCase().trim()
          : ""
        : "",
      GuradianDOB: a.nomineeDateofBirth
        ? checkAgeLimit(new Date(a.nomineeDateofBirth))
          ? a.gaurdianDateofBirth
            ? convertDayJsToDate(a.gaurdianDateofBirth)
            : ""
          : ""
        : "",
      GuradianEmail: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianEmail || ""
        : "",
      GuradianMobile: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianMobileNumber || ""
        : "",
      GuradianRealtionWithNominee: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianRelationWithNominee?.value
          ? a.gaurdianRelationWithNominee.value.toUpperCase()
          : ""
        : "",
      GuradianRelationOthers: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianRelationOthers
          ? a.gaurdianRelationOthers.toUpperCase()
          : ""
        : "",
      GuradianAddress: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddress
          ? a.gaurdianAddress.toUpperCase().trim() || ""
          : ""
        : "",
      GuradianAddressPinCode: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddressPinCode || ""
        : "",
      GuradianAddressCity: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddressCity
          ? a.gaurdianAddressCity.toUpperCase().trim() || ""
          : ""
        : "",
      GuradianAddressState: checkAgeLimit(new Date(a.nomineeDateofBirth))
        ? a.gaurdianAddressState?.value
          ? a.gaurdianAddressState.value.toUpperCase()
          : ""
        : "",
      NomineeIDProof: !a.nomineeIDProof ? "" : a.nomineeIDProof,
      NomineeIDProofNo: (a.nomineeIDProofNo || "").toUpperCase(),
      Pincode: a.nomineeAddressPinCode || "",
      City: (a.nomineeAddressCity || "").toUpperCase().trim(),
      State: (a.nomineeAddressState?.value || "").toUpperCase(),
    }));
    // console.log("valuesAfter", values);
    let obj: any = {
      nominee_json: ArrayObject,
      nominee_statement: nominationInformation,
    };

    UpdateNomineeDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        //  console.log("responseDataupdate", responseData);
        setloading(false);

        sessionStorage.setItem(
          "nomineeRequestID",
          responseData.data.request_id,
        );
        SaveIPAddress(responseData.data.request_id);
      })
      .catch((error: any) => {
        setloading(false);
      });
  }

  const SaveIPAddress = (ipaddress: any) => {
    let obj: any = {
      request_id: ipaddress,
      update_component: "nominee",
      latitude: sessionStorage.getItem("latitude"),
      longitude: sessionStorage.getItem("longitude"),
    };
    SaveIpAddressAPICall(obj)
      .then((response: any) => {
        // console.log("response", response.data.data);

        navigate("/nomineeUpdate/esign");
      })
      .catch((error: any) => {
        seterrormessage("latitude and longitude not found");
        setTimeout(() => {
          seterrormessage("");
        }, 5000);
      });
  };
  // console.log("prefillData", prefillData);
  return (
    <div className={Styles.mainWrapperTop}>
      <SnackBar message={errormessage} />
      <div className={Styles.mainWrapper}>
        <div className={Styles.step}>
          <img src={keyboardicon} /> Step 2 of 3
        </div>
        <div className={Styles.headerSection}>
          <p className={Styles.signup}>Add Nominee Details</p>
        </div>
        <>
          {!prefilloading ? (
            <Formik
              validationSchema={schema}
              initialValues={{
                nominees: [...prefillData],
              }}
              onSubmit={(values: any) => {
                // console.log("submit", values.nominees);
                nomineeDetailsSubmit(values.nominees);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldError,
                setErrors,
                setFieldTouched,
                setTouched,
              }) => {
                const { nominees } = values;
                // console.log("errors", errors);
                // console.log("values", values);

                const percentageTotal = values.nominees
                  .map((a: any) =>
                    a.percentageofShare === ""
                      ? 0
                      : parseFloat(a.percentageofShare),
                  )
                  .reduce((sum: any, current: any) => sum + current, 0);
                // console.log("values", values);
                return (
                  <Form style={{ width: "100%" }}>
                    <div className={Styles.wrapper}>
                      <div className={Styles.leftContainer}>
                        {/* <div> */}
                        <div className={Styles.nomineeDetailsHeader}>
                          <p className={Styles.Header}>
                            {assignIndex === 0
                              ? "Nominee Details"
                              : `Adding Nominee ${assignIndex + 1}`}
                          </p>
                          <label className={Styles.additionalDetailsCheckbox}>
                            <Checkbox
                              checked={Boolean(
                                showAdditionalDetails[assignIndex],
                              )}
                              onChange={(event) => {
                                const updatedAdditionalDetails = [
                                  ...showAdditionalDetails,
                                ];
                                updatedAdditionalDetails[assignIndex] =
                                  event.target.checked;
                                setShowAdditionalDetails(
                                  updatedAdditionalDetails,
                                );
                              }}
                              size="small"
                            />
                            Add Additional Details
                          </label>
                        </div>
                        {/* </div> */}
                        <FieldArray
                          name="nominees"
                          render={(arrayHelpers) => (
                            <div style={{ width: "100%" }}>
                              {nominees.map((nominee, index) => {
                                const touchedData =
                                  touched?.nominees?.[index] || {};
                                const errorData = errors.nominees
                                  ? errors.nominees[index]
                                  : {};

                                // console.log("touchedData", touched);
                                // console.log("errorData", errorData);

                                return (
                                  <NomineeForm
                                    handleNomineeDelete={handleNomineeDelete}
                                    handleNomineeEdit={handleNomineeEdit}
                                    index={index}
                                    currentIndex={assignIndex}
                                    nominee={nominee}
                                    touchedData={touched}
                                    errorData={errorData}
                                    handleChangeField={handleChangeField}
                                    setFieldValue={setFieldValue}
                                    values={values}
                                    handleBlur={handleBlur}
                                    relationError={false}
                                    ageError={false}
                                    relationShipData={relationShipData}
                                    address={address}
                                    setErrors={setErrors}
                                    errors={errors}
                                    gaurdianData={gaurdianData}
                                    statesData={statesData}
                                    nominees={nominees}
                                    setTouched={setTouched}
                                    touched={touched}
                                    showAdditionalDetails={Boolean(
                                      showAdditionalDetails[index],
                                    )}
                                    showGuardianAdditionalDetails={Boolean(
                                      showGuardianAdditionalDetails[index],
                                    )}
                                    onGuardianAdditionalDetailsChange={(
                                      checked,
                                    ) => {
                                      setShowGuardianAdditionalDetails(
                                        (currentDetails) => {
                                          const updatedDetails = [
                                            ...currentDetails,
                                          ];
                                          updatedDetails[index] = checked;
                                          return updatedDetails;
                                        },
                                      );
                                    }}
                                  />
                                );
                              })}
                            </div>
                          )}
                        />
                        <div>
                          {nominees?.length !== 3 ? (
                            <Button
                              className={Styles.addNomineeButton}
                              onClick={() => {
                                handleNomineeAdd(
                                  values,
                                  setFieldValue,
                                  setFieldTouched,
                                );
                                window.scrollTo(0, 0);
                              }}
                              disabled={
                                percentageTotal >= 100 ||
                                assignIndex === 2 ||
                                Object.keys(errors).length > 0 ||
                                Object.keys(touched).length === 0
                              }
                              id="nomineesAddNomineeButton"
                              sx={{
                                borderRadius: "8px",
                                height: "40px",
                                background: "#3263E5",
                                fontSize: "12px",
                                visibility:
                                  assignIndex !== 2 ? "visible" : "hidden",
                                "&:hover": {
                                  background: "#3263E5",
                                },
                              }}
                              variant="contained"
                              size="small"
                              startIcon={<AddBoxOutlinedIcon />}
                            >
                              Add Nominee {assignIndex + 2}
                            </Button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>

                      <div className={Styles.nominationInformation}>
                        <div className={Styles.nominationInformationText}>
                          I/We hereby choose to receive the following nomination
                          information in the periodic statement of
                          holdings/accounts:
                        </div>
                        <Stack direction={"row"} gap={"24px"}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  nominationInformation === "nominee_name"
                                }
                                icon={<img src={proofEmpty} alt="" />}
                                checkedIcon={<img src={proofDone} alt="" />}
                                onChange={() => {
                                  setNominationInformation((current) =>
                                    current === "nominee_name"
                                      ? ""
                                      : "nominee_name",
                                  );
                                }}
                                style={{
                                  width: "30px",
                                  height: "30px",
                                }}
                              />
                            }
                            label={
                              <div className={Styles.checkboxlabel}>
                                Nominee Name(s)
                              </div>
                            }
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  nominationInformation === "nominee_status"
                                }
                                icon={<img src={proofEmpty} alt="" />}
                                checkedIcon={<img src={proofDone} alt="" />}
                                onChange={() => {
                                  setNominationInformation((current) =>
                                    current === "nominee_status"
                                      ? ""
                                      : "nominee_status",
                                  );
                                }}
                                style={{
                                  width: "30px",
                                  height: "30px",
                                }}
                              />
                            }
                            label={
                              <div className={Styles.checkboxlabel}>
                                Nomination Status (Yes/No)
                              </div>
                            }
                          />
                        </Stack>
                      </div>
                      <ErrorSnackBar message={rejectMessage} />
                      {backdrop && <StartOverBackDrop />}
                      <div className={Styles.rightContainer}>
                        <div className={Styles.ButtonSection}>
                          <div className={Styles.Buttons}>
                            <div style={{ width: "100%" }}>
                              {percentageTotal !== 100 ? (
                                <LoadingButton
                                  variant="contained"
                                  type="submit"
                                  // onClick={nomineeDetailsSubmit}
                                  disabled={
                                    values.nominees[0].nomineeFullName === "" ||
                                    values.nominees[0].relationShip === "" ||
                                    percentageTotal !== 100 ||
                                    Object.keys(errors).length > 0
                                  }
                                  sx={{ height: "50px", marginTop: "20px" }}
                                  loading={loading}
                                  id="nomineesContinueButton"
                                  className={Styles.continue}
                                >
                                  {percentageTotal > 100
                                    ? "Percentage is > 100"
                                    : "Percentage is < 100"}
                                </LoadingButton>
                              ) : (
                                <LoadingButton
                                  variant="contained"
                                  type="submit"
                                  // onClick={nomineeDetailsSubmit}
                                  sx={{ height: "50px", marginTop: "20px" }}
                                  disabled={
                                    values.nominees[0].nomineeFullName === "" ||
                                    values.nominees[0].relationShip === "" ||
                                    percentageTotal !== 100 ||
                                    Object.keys(errors).length > 0
                                  }
                                  loading={loading}
                                  id="nomineesContinueButton"
                                  className={Styles.continue}
                                >
                                  Continue
                                </LoadingButton>
                              )}
                            </div>
                          </div>
                          {/* <div className={Styles.startOverSection}>
                          <img src={icon} className={Styles.iconImage} />
                          <p className={Styles.paratext}>
                            {" "}
                            if the above mentioned info not yours
                            <span
                              className={Styles.startoverbutton}
                              onClick={handleStartOver}
                            >
                              Start Over
                            </span>
                          </p>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          ) : (
            <Stack height={"90vh"}>
              <BackDrop />
            </Stack>
          )}
        </>
      </div>
    </div>
  );
}
